export default __webpack_public_path__ + "static/media/Pedestre.ad13baf3.svg";